import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs/Observable";

@Injectable()

export class ConfigService {

  configUrl = "assets/config/config.json";

  private config: Object = null;
  private env: Object = null;


  constructor(public http: HttpClient) {

  }

  public getConfig(key: any) {
    return this.config[key];
  }

  public load() {

    return new Promise((resolve, reject) => {
      this.http.get(this.configUrl).subscribe((responseData: any) => {
        this.config = responseData;
        resolve(true);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/dbservice/configservice.ts